<template>
  <div class="checkout-view dark:bg-background">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="mb-">
        <h1 class="text-3xl font-bold text-foreground mb-2 text-center">
          Checkout
        </h1>
        <!-- <p class="text-gray-600 text-center">
          You're just one step away from unlocking your potential!
        </p> -->
      </div>

      <CheckoutComponent />
    </div>
  </div>
</template>

<script>
import CheckoutComponent from "@/components/pricing/CheckoutComponent.vue";

export default {
  name: "CheckoutView",
  components: {
    CheckoutComponent,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.checkout-view {
  min-height: 100vh;
}
</style>
